export default __webpack_public_path__ + "static/media/verak_logo.aba1f8f2.svg";